// plugins/fetchSiteInfo.js
import { useMainStore } from "~/composables/store"; // 引入 Pinia Store
import { getCurrentServer } from "../utils/globalData";
import { watch, unref } from "vue";
import { normalizeSharedLocale } from "../utils/shareLocale.js";
export default defineNuxtPlugin(async (nuxtApp) => {
  // if (process.server) {
    const store = useMainStore();
    const headers = useRequestHeaders();
    const sharedLocale = normalizeSharedLocale(useRoute().query.locale);
    if (sharedLocale && nuxtApp.$i18n?.setLocale) {
      useCookie("i18n_current_locale").value = sharedLocale;
      if (import.meta.client) {
        try {
          for (const key of ["i18n_current_locale", "current_user_center_locale", "now-locale"])
            window.localStorage.setItem(key, sharedLocale);
        } catch { /* Locale can still be applied when browser storage is unavailable. */ }
      }
      await nuxtApp.$i18n.setLocale(sharedLocale);
    }
    const customFetch = (url, options) => (nuxtApp.$customFetch || $fetch)(url, options, headers);
   
    const currentServer = getCurrentServer(headers);

    watch(
      () => unref(nuxtApp.$i18n?.locale || nuxtApp.$i18n?.global?.locale),
      (locale) => store.applyShopLocale(locale),
      { immediate: true, flush: "sync" },
    );

    // Sassmall shop bootstrap owns the site identity and low-code tenant context.
    await store.fetchStoreInfo(currentServer, customFetch, headers);
    const localeCookie = useCookie("i18n_current_locale");
    if (process.client && localeCookie.value && window.localStorage.getItem("has_visited") &&
      !window.localStorage.getItem("i18n_current_locale")) {
      window.localStorage.setItem("i18n_current_locale", localeCookie.value);
    }
    const defaultLocale = store.getMallSiteDefaultLocale(currentServer);
    if (!localeCookie.value && defaultLocale && nuxtApp.$i18n?.setLocale) {
      await nuxtApp.$i18n.setLocale(defaultLocale);
    }
    await store.fetchLayoutConfig(customFetch, headers);
  // }
});
